
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 700 600"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill":"#0DB02B","d":"M0 0h700v600H0z"}}),_c('path',{attrs:{"fill":"#FFF","d":"M0 0h700v400H0z"}}),_c('path',{attrs:{"fill":"#e05206","d":"M0 0h700v200H0z"}}),_c('circle',{attrs:{"cx":"350","cy":"300","r":"85","fill":"#e05206"}})])
          )
        }
      }
    